/**
 * campaign-readiness / campaign_resolution 응답을 배너 표시용으로 변환하는 **순수 매핑**.
 *
 * ⛔ 판정 로직 없음. 백엔드 evaluate_project_readiness 가 이미 내린 결론
 *    (ready/required/reason)을 색·문구·행동유도(CTA)로 바꾸기만 한다.
 *
 * 입력(readiness): {
 *   required, ready, reason, missing_keys,
 *   rule_set_count, evaluable_rule_set_count, fallback_campaign_id
 * }
 */

const REASON_TEXT = {
    missing_input_keys: '배정 규칙이 쓰는 질문이 신청서에 아직 없습니다.',
    no_campaign_mapping: '배정할 평가지가 하나도 없습니다.',
    no_required_keys: '조건이 없는 규칙만 있어 어느 평가지로 보낼지 판단할 수 없습니다.',
};

export const reasonText = (reason) => REASON_TEXT[reason] || '아직 신청받을 준비가 되지 않았습니다.';

/**
 * @returns {{variant, icon, title, detail, ctaLabel, ctaAction, missingKeys}}
 *   variant: bootstrap 색 (success/danger/warning/secondary)
 *   ctaAction: 'create-question' | 'connect-fallback' | null  — 컨테이너가 해석
 */
export const readinessView = (readiness) => {
    if (!readiness) {
        return {
            variant: 'secondary', icon: 'bi-hourglass-split',
            title: '준비 상태를 불러오는 중입니다…', detail: '', ctaLabel: null, ctaAction: null, missingKeys: [],
        };
    }

    const {ready, required, reason, missing_keys: missingKeys = [], rule_set_count: ruleSetCount = 0} = readiness;

    if (ready) {
        if (required) {
            return {
                variant: 'success', icon: 'bi-check-circle-fill',
                title: '신청 받을 수 있습니다.',
                detail: `신청자의 답변에 따라 평가지가 자동으로 배정됩니다. (배정 규칙 ${ruleSetCount}개)`,
                ctaLabel: null, ctaAction: null, missingKeys: [],
            };
        }
        return {
            variant: 'success', icon: 'bi-check-circle-fill',
            title: '신청 받을 수 있습니다.',
            detail: '배정 규칙이 없어, 모든 신청자가 기본 평가지로 배정됩니다.',
            ctaLabel: null, ctaAction: null, missingKeys: [],
        };
    }

    // ready=false — 신청 불가. 사유별 CTA.
    const base = {variant: 'danger', icon: 'bi-exclamation-triangle-fill', title: '지금은 이 프로젝트로 신청할 수 없습니다.'};
    if (reason === 'missing_input_keys') {
        return {
            ...base,
            detail: `${reasonText(reason)} 빠진 질문: ${missingKeys.join(', ')}`,
            ctaLabel: '이 질문 바로 만들기', ctaAction: 'create-question', missingKeys,
        };
    }
    if (reason === 'no_campaign_mapping') {
        return {
            ...base,
            detail: reasonText(reason),
            ctaLabel: '기본 평가지 연결하기', ctaAction: 'connect-fallback', missingKeys: [],
        };
    }
    return {
        ...base,
        detail: reasonText(reason),
        ctaLabel: null, ctaAction: null, missingKeys: missingKeys || [],
    };
};
